// import React from "react";
import React, { useState, useEffect } from "react";
import getAxiosInstance from "./../../Utils/axios";

import Swal from "sweetalert2";

const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.addEventListener("mouseenter", Swal.stopTimer);
    toast.addEventListener("mouseleave", Swal.resumeTimer);
  },
});

function AddUpdates() {
  const [isLoading, setIsLoading] = useState(false);
  const [AssignLevel, setAssignLevel] = useState(0);

  const [upload, setUpload] = useState(null);

  const saveHandler = () => {
    setIsLoading(true);
    let link = "/admin/add-new-update";

    let params = {
      upload: upload,
      platform: AssignLevel,
    };
    const formData = new FormData();

    formData.append("upload", upload);
    formData.append("platform", AssignLevel);
    // const data = Object.keys(params)
    //   .map((key) => `${key}=${encodeURIComponent(params[key])}`)
    //   .join("&");

    getAxiosInstance()
      .post(link, formData, {
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
      })
      .then((res) => {
        setIsLoading(false);
        // console.log(res.data)
        if (res.data.status === "success") {
          Toast.fire({
            icon: "success",
            title: `Update successfully.`,
          });
          // if (!userID) reset();
        } else if (res.data.status === "error")
          Toast.fire({ icon: "error", title: res.data.message });
        else Toast.fire({ icon: "error", title: "Cannot Process Request" });
      })
      .catch((err) => {
        setIsLoading(false);
        if (err.response.status === 401)
          Toast.fire({ icon: "error", title: "Unauthorized Access" });
        console.log(err);
      });
  };
  return (
    <div>
      <div className="content-wrapper">
        <div className="content-header">
          <div className="container-fluid">
            <div className="row justify-content-center">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <h1 className="m-0 text-bold">Add New Update</h1>
                    <div className="row mt-3">
                      <div className="col-md-4">
                        <input
                          type="file"
                          className="form-control"
                          onChange={(e) => setUpload(e.target.files[0])}
                        />
                      </div>
                    </div>

                    <h1 className="m-0 mt-4 text-bold">Select a platform</h1>
                    <div className="row mt-3">
                      <div className="col-md-5">
                        <select
                          className="form-control"
                          value={AssignLevel}
                          onChange={(e) => {
                            // if (notAdmin) {
                            //   if (allowedLevel > e.target.value)
                            //     return Toast.fire({
                            //       icon: "error",
                            //       title:
                            //         "You do not have permission for this level.",
                            //     });
                            // }
                            setAssignLevel(e.target.value);
                          }}
                        >
                          <option value={0}>Select Platform</option>
                          <option value={"android"}>Android</option>
                          <option value={"windows"}>Windows</option>
                        </select>
                      </div>
                    </div>

                    <div className="row mt-3">
                      <div className="col-md-5">
                        <button
                          type="button"
                          className="btn btn-dark ml-2 float-right"
                          onClick={(e) => saveHandler()}
                          disabled={isLoading}
                        >
                          Add New Update
                        </button>
                        {/* {!userID && ( */}
                        {/* <button
                          type="button"
                          className="btn btn-dark float-right"
                          // onClick={(e) => reset()}
                          // disabled={isLoading}
                        >
                          Reset
                        </button> */}
                        {/* )} */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddUpdates;
